import React from 'react';
import classNames from 'classnames';
import ToolTip from '../ToolTip';
import { InfoIcon } from '../icons';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ palette }) => ({
    root: {},
    secondary: {
        color: palette.secondary.main,
    },
    error: {
        color: palette.error.main,
    },
    warning: {
        color: palette.warning.main,
    },
    info: {
        color: palette.info.main,
    },
    success: {
        color: palette.success.main,
    },
    icon: {
        verticalAlign: 'top',
    },
}));
function IconTooltip({ content, className, iconSize = 'small', position, align, theme = 'secondary', }) {
    const classes = useStyles();
    return (React.createElement(ToolTip, { spanClassName: classNames(className, classes.root), align: align, position: position, content: content },
        React.createElement(InfoIcon, { size: iconSize, className: classNames(classes.icon, classes[theme]) })));
}
export default IconTooltip;
//# sourceMappingURL=IconTooltip.js.map